import { WebApi } from "./api";

/**
 * 方法服务
 */
export class MethodService implements IMethodService {
  private req: IRequestInfo = {
    moduleName: "",
    className: "",
    method: "",
    args: {}
  };
  private clsService?: ClsService;
  args: {} = {};
  isBusy?: boolean = false;
  isSuccess?: boolean | any = null;
  serviceError?: string = "";
  data?: any = null;
  constructor(
    module?: string,
    cls?: string,
    method?: string,
    clsService?: ClsService
  ) {
    this.req = {
      moduleName: module as string,
      className: cls as string,
      ["method"]: method as string,
      args: {}
    };
    this.args = this.req.args;
    this.isBusy = false;
    this.clsService = clsService;
  }

  public get ClassService() {
    return this.clsService;
  }

  public invoke(args?: {}) {
    this.invokeAsyn(args);
  }

  public async invokeAsyn(args?: {}) {
    let api = new WebApi();
    if (args) {
      this.args = args;
    }
    this.req.args = this.args;
    this.isBusy = true;
    try {
      let res = await api.invoke(this.req);
      this.isSuccess = res.data.isSuccess;
      if (this.isSuccess) {
        this.serviceError = "";
        this.data = res.data.data;
      } else {
        this.serviceError = res.data.error;
        this.data = null;
      }
      return res;
    } catch (error) {
      let x: IRes = {
        data: {
          isSuccess: false,
          data: null,
          error
        }
      };
      return x;
    } finally {
      this.isBusy = false;
    }

    //     .then(res => {
    //       this.isSuccess = res.data.isSuccess;
    //       if (this.isSuccess) {
    //         this.serviceError = "";
    //         this.data = res.data.data;
    //       } else {
    //         this.serviceError = res.data.error;
    //         this.data = null;
    //       }
    //       resolve(res);
    //     })
    //     .catch(res => {
    //       reject(res);
    //     })
    //     .finally(() => {
    //       this.isBusy = false;
    //     });
    // })
  }
}

/**
 * 类服务
 */
export class ClsService {
  private module: string;
  private cls: string;

  isBusy: boolean;

  constructor(module: string, cls: string) {
    this.module = module;
    this.module = cls;
    this.isBusy = false;
  }

  protected getMethodService(methodName) {
    return new MethodService(this.module, this.cls, methodName, this);
  }
}

export class TableQueryService extends MethodService {
  pagination: IPagination;
  headers?: ITableHeader[];
  props?: IProp[];
  totalItems?: number;

  constructor(
    module?: string,
    cls?: string,
    method?: string,
    clsService?: ClsService
  ) {
    super(module, cls, method, clsService);
    this.pagination = { rowsPerPage: 10, sortBy: "Id" };
    this.headers = [];
    this.props = [];
  }

  public get Skip() {
    if (this.pagination.page && this.pagination.rowsPerPage) {
      let skip =
        (this.pagination.page.valueOf() - 1) *
        this.pagination.rowsPerPage.valueOf();
      if (skip < 0) {
        skip = 0;
        return skip;
      }
    }
    return 0;
  }
}

export class TableManager extends ClsService {
  queryService: TableQueryService;
  saveService: MethodService;
  deleteService: MethodService;

  constructor(module: string, cls: string) {
    super(module, cls);
    this.queryService = new TableQueryService(module, cls, "query");
    this.saveService = this.getMethodService("save");
    this.deleteService = this.getMethodService("delete");
  }

  public query() {
    this.isBusy = true;
    this.queryService.invokeAsyn().finally(() => {
      this.isBusy = false;
    });
  }

  public save() {
    this.isBusy = true;
    this.saveService.invokeAsyn().finally(() => {
      this.query();
    });
  }

  public delete() {
    this.isBusy = true;
    this.deleteService.invokeAsyn().finally(() => {
      this.query();
    });
  }
}
